import { z } from 'zod'

export const formSchema = z.object({
  paymentMethod: z.string(),
  propertyValue: z.union([
    z.number().min(1, `Property Value must be greater than 0`),
    z.literal('').refine((val) => val !== '', `Property Value cannot be empty`),
  ]),
  loanRequired: z.union([
    z.number().min(1, `Loan Amount must be greater than 0`),
    z.literal('').refine((val) => val !== '', `Loan Amount cannot be empty`),
  ]),
  term: z.union([
    z.number().min(1, `Term must be greater than 0`),
    z.literal('').refine((val) => val !== '', `Term cannot be empty`),
  ]),
  businessType: z.string(),
  rent: z.coerce.number().optional(),
  mortgageClass: z.string(),
  initialPeriod: z.string(),
  region: z.string(),
  sortedBy: z.string(),
  lender: z.string(),
  discountedPurchasePrice: z.coerce.number().optional(),
  shareValue: z.coerce.number().optional(),
  percentagePurchased: z.coerce.number().optional(),
  buildingUse: z.string(),
  creditQuestions: z.array(z.string()),
  others: z.string(),
  fees: z.string(),
  cashback: z.string().optional(),
})

export type FormSchema = z.infer<typeof formSchema>
